module.exports = __webpack_public_path__ + "static/media/not-found-bg.fd2dfe79.jpg";